@import 'styles/variables.scss';
@import 'styles/breakpoints.scss';

.page {
  max-width: 920px;
  margin: 0 auto;
  padding: 8px 0 40px;
  color: #333333;
  font-size: 1rem;
  line-height: 1.65;
  text-align: left;

  p {
    margin: 0 0 $spacer;
  }

  a {
    color: $primary-color;
    overflow-wrap: anywhere;
  }

  @include breakpoint-down(sm) {
    padding-top: 0;
    font-size: 0.9375rem;
    line-height: 1.55;
  }
}

.section {
  margin-top: $spacer * 2;

  h2 {
    margin: 0 0 $spacer;
    color: #333333;
    font-family: 'Roboto Condensed', sans-serif;
    font-size: 1.5rem;
    line-height: 1.3;
  }

  @include breakpoint-down(sm) {
    margin-top: $spacer * 1.5;

    h2 {
      font-size: 1.25rem;
    }
  }
}

.list {
  margin: 0;
  padding-left: 1.35rem;

  li {
    margin-bottom: $spacer;
    padding-left: 0.25rem;
  }
}

.emphasized {
  font-weight: 700;
}
